import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initCaseListingWindowsOsFlag } from './shared/utils/osWindows';
import "core-js/stable";
import "regenerator-runtime/runtime";

initCaseListingWindowsOsFlag();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
